<script setup>
import { shallowRef, onMounted } from 'vue'
import { useApi } from '@provise/composables/api'
import SelectId from '@/components/select/selectIdObject.vue'
const model = defineModel()
const departments = shallowRef([])
const departmentsQuery = shallowRef({
  filter: 'type.key',
  filter_id: 'provider',
  onPage: 500,
  page: 1,
})

const { refresh: fetchDepartments } = useApi({
  url: 'departments',
  model: departments,
  query: departmentsQuery,
  watch: [departmentsQuery],
  pick: d => d.data || [],
})
// watch(
//   model,
//   async mv => {
//     if (mv?.id) {
//       await fetchDepartments()
//     }
//   },
//   { immediate: true }
// )
// function onSearchDepartments(search) {
//   if (!(search + '').length) {
//     return
//   }
//
//   departmentsQuery.value = { ...departmentsQuery.value, search }
// }

onMounted(async () => {
  await fetchDepartments()
})
</script>
<template>
  <SelectId :options="departments" v-model="model" v-bind="$props" />
  <!--  @search="onSearchDepartments"-->
</template>
